import { render, staticRenderFns } from "./TextosDescritivos.vue?vue&type=template&id=57ec4e92&scoped=true&"
import script from "./TextosDescritivos.vue?vue&type=script&lang=js&"
export * from "./TextosDescritivos.vue?vue&type=script&lang=js&"
import style0 from "./TextosDescritivos.vue?vue&type=style&index=0&id=57ec4e92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ec4e92",
  null
  
)

export default component.exports